module.exports = __webpack_public_path__ + "static/media/marcus_vinicius_do_nascimento.5d176b9e.png";